import { Injectable } from '@angular/core';

@Injectable()
export class SessionStorageService {
  public request: any;
  public response: any;
  public key: string = '';

  constructor() {}
}
